import http from '../plugins/axios'

export const getAllBannerList = async (params) => {
  try {
    const response = await http.get(`/api/v2/banners`, { params })
    return response.data
  } catch(error) {
    throw error
  }
}


export const addBanner = async (formData) => {
  try {
    const response = await http.post(`/api/v2/banners`, formData)
    return response.data
  } catch(error) {
    throw error
  }
}

export const updateBanner = async (bannerId, formData) => {
  try {
    const response = await http.post(`/api/v2/banners/${bannerId}`, formData)
    return response.data
  } catch(error) {
    throw error
  }
}

export const deleteDataBanner = async (bannerId) => {
  try {
    const response = await http.delete(`/api/v2/banners/${bannerId}`)
    return response.data
  } catch(error) {
    throw error
  }
}